// Libs
import { AxiosError } from 'axios';
import { SWRResponse } from 'swr';
// App
import { useSWRAxiosGetRequest } from 'app-shared/lib/api/utils/swr-axios-request.hooks';
import { API_COMMON_BASE_URL } from 'app-shared/lib/api/utils/api.constants';
import { APP_VERSION_URL, FETCH_ONCE_SWR_OPTIONS } from './app-version.constants';
import { AppVersion } from './app-version.interface';

/**
 * Get the version of the running API, the one printed on the cash register attestations; fetched once per page load
 */
export const useGetAppVersion = (): SWRResponse<AppVersion, AxiosError> => {
  const appVersionResponse = useSWRAxiosGetRequest<AppVersion>(
    `${API_COMMON_BASE_URL}/${APP_VERSION_URL}`,
    FETCH_ONCE_SWR_OPTIONS
  );

  return appVersionResponse;
};
